var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomateDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "automate-document-icon-group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "automate-document-icon-group2",
    transform: "translate(-1070.000000, -208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "automate-document-icon-group3",
    transform: "translate(1070.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "automate-document-icon-rect1",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "automate-document-icon-group4",
    transform: "translate(3.995000, 2.000000)",
    fill: "#718191",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "automate-document-icon-polygon1",
    points: "36.005 12 37.885 7.88 42.005 6 37.885 4.12 36.005 0 34.125 4.12 30.005 6 34.125 7.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "automate-document-icon-polygon2",
    points: "13.005 12 14.885 7.88 19.005 6 14.885 4.12 13.005 0 11.125 4.12 7.005 6 11.125 7.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "automate-document-icon-polygon3",
    points: "36.005 23 34.125 27.12 30.005 29 34.125 30.88 36.005 35 37.885 30.88 42.005 29 37.885 27.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.425,16.24 L25.765,10.58 C25.365,10.2 24.865,10 24.345,10 C23.825,10 23.325,10.2 22.925,10.58 L0.585,32.92 C-0.195,33.7 -0.195,34.96 0.585,35.74 L6.245,41.4 C6.645,41.8 7.145,42 7.665,42 C8.185,42 8.685,41.8 9.085,41.42 L31.425,19.08 C32.205,18.3 32.205,17.02 31.425,16.24 Z M24.345,14.84 L27.165,17.66 L24.825,20 L22.005,17.18 L24.345,14.84 Z M7.665,37.18 L4.845,34.36 L19.185,20 L22.005,22.82 L7.665,37.18 Z",
    id: "automate-document-icon-path1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomateDocumentIcon);
export default __webpack_public_path__ + "static/media/automate-document-icon.06ecf7d2.svg";
export { ForwardRef as ReactComponent };